import { render, staticRenderFns } from "./pasos.vue?vue&type=template&id=4968a3a9&scoped=true"
import script from "./pasos.vue?vue&type=script&lang=js"
export * from "./pasos.vue?vue&type=script&lang=js"
import style0 from "./pasos.vue?vue&type=style&index=0&id=4968a3a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4968a3a9",
  null
  
)

export default component.exports